const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getAvailablePacks(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/program-packs/available`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch available packs');
  }
  
  const data = await response.json();
  return data.packs;
}

export async function getInstalledPacks(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/program-packs/installed`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch installed packs');
  }
  
  const data = await response.json();
  return data.installations;
}

export async function getPack(orgId, packId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/program-packs/${packId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }
    throw new Error('Failed to fetch pack');
  }
  
  const data = await response.json();
  return data.pack;
}

export async function installPack(orgId, packId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/program-packs/install`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify({ packId })
  });
  
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to install pack');
  }
  
  return response.json();
}

export async function uninstallPack(orgId, packId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/program-packs/uninstall`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify({ packId })
  });
  
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to uninstall pack');
  }
  
  return response.json();
}
